import { Component, Input, OnInit } from '@angular/core';
import { IAdminModalComponent, IAdminModalData, IAwsServices } from '../../domain/models/admin-modal';

@Component({
	selector: 'app-admin-org-collection',
	templateUrl: './admin-org-collection.component.html',
	styleUrls: ['./admin-org-collection.component.scss'],
})
export class AdminOrgCollectionComponent implements IAdminModalComponent, OnInit {
	@Input() data: IAdminModalData<{}>;
	awsServicesList: string[] = Object.values(IAwsServices);
	dict = new CustomCollection();
	Object = Object;
	constructor() {}

	ngOnInit() {
		this.dict.items = [];
		for (const [key, value] of Object.entries(this.data.options['custom_collection_cycle'])) {
			this.dict.set(key, value);
			this.awsServicesList = this.awsServicesList.filter((e) => e !== key);
		}
	}

	onDelete(key) {
		this.dict.delete(key);
		this.awsServicesList.push(key);
	}

	onChange(key) {
		this.awsServicesList = this.awsServicesList.filter((e) => e !== key);

		this.dict.set(key, 1);
	}

	onSubmit(): void {
		const options = {
			id: this.data.options['org_id'],
			items: this.dict.items,
		};

		this.closeEvent(options);
	}

	closeEvent(e?: {}): void {}
}

// eslint-disable-next-line max-classes-per-file
export class CustomCollection {
	items = {};
	constructor() {
		this.items = {};
	}
	public has(key) {
		return key in this.items;
	}
	public set(key, value) {
		this.items[key] = value;
	}
	public get(key) {
		return this.items[key];
	}
	public delete(key) {
		if (this.has(key)) {
			delete this.items[key];
			return true;
		}
		return false;
	}
}
